/**
 * The caller's organizations, invitations and deployment role, for the avatar menu's org
 * switcher and the setup page.
 */

import { useAtomValueRawSync } from 'jotai';

import { authSession } from '@/auth/authSession';
import { meAtom } from '@/state/api/meAtoms';
import type { OrgRef, PendingInvite } from '@/types/auth';

interface Identity {
    orgs: OrgRef[];
    pendingInvites: PendingInvite[];
    platformAdmin: boolean;
}

interface MeResult extends Identity {
    isLoading: boolean;
    error: Error | null;
    /** From the auth session, so the switcher can mark the current org. */
    activeOrgId: string | null;
}

const EMPTY: Identity = { orgs: [], pendingInvites: [], platformAdmin: false };

export function useMe(): MeResult {
    const { me, isLoading, error } = useAtomValueRawSync(meAtom);
    const identity = me === null ? EMPTY : {
        orgs: me.orgs,
        pendingInvites: me.pendingInvites,
        platformAdmin: me.platformAdmin,
    };
    return {
        ...identity,
        isLoading,
        error,
        activeOrgId: authSession.getActiveOrg(),
    };
}
